import moment from 'moment';
// import 'moment/locale/zh-hk';

// moment.locale('zh-hk');

export default moment;
